<div>
    <div class="form-group">
        <label>Number of Components</label>
        <input type="number" class="form-control" v-model="numberOfComponents" @input="onNumberOfComponentsInput" @blur="onNumberOfComponentsBlur" >
    </div>
    <div class="text-info" v-if="numberOfComponents > 0">
        <p>Decreasing the number of compartments will remove compartments from the bottom of the list.</p>
        <p>Increasing the number of compartments will add compartments to the bottom of the list</p>
    </div>
    <div class="table-responsive pt-4">
        <table class="table table-hover mb-0">
            <thead>
            <tr class="d-flex">
                <th class="col-2"></th>
                <th class="col-2" v-for="(product, i) in products" :key="i">
                    {{ product.name }}
                </th>
                <th class="col-2"></th>
            </tr>
            </thead>
            <tbody>
            <tr class="d-flex" v-for="(vehicleCompartmentProduct, index) in vehicleCompartmentProducts" :key="index">
                <td class="col-2">{{ vehicleCompartmentProduct.vehicleCompartment.name }}</td>
                <td v-for="(prod, itemIndex) in products" :key="itemIndex" class="col-2">
                    <div v-if="vehicleCompartmentProduct.compartmentProducts.find(x => x.productId === prod.productId)">
                        <input type="number" class="form-control" v-model="vehicleCompartmentProduct.compartmentProducts.find(x => x.productId === prod.productId).capacity" @blur="onCapacityInputBlur(vehicleCompartmentProduct)">
                    </div>
                </td>
                <td class="col-2">
                    <button class="btn btn-primary" @click="removeCompartment(vehicleCompartmentProduct, index)">Remove</button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
